import * as signalR from "@microsoft/signalr";

const getHubUrl = (tenantDomain: string) => {
  const path = `/api/hubs/orders?tenantDomain=${tenantDomain}`;
  return process.env.NODE_ENV === "production"
    ? path
    : `http://localhost:5079${path}`;
};

export const createOrderHubConnection = () => {
  const tenantDomain = encodeURIComponent(window.location.host);
  return new signalR.HubConnectionBuilder()
    .configureLogging(signalR.LogLevel.None)
    .withUrl(getHubUrl(tenantDomain), {
      withCredentials: true,
      transport: signalR.HttpTransportType.ServerSentEvents | signalR.HttpTransportType.LongPolling,
      accessTokenFactory: () => {
        try {
          const raw = localStorage.getItem("user");
          if (!raw) {
            return "";
          }
          const user = JSON.parse(raw);
          return user?.accessToken || "";
        } catch {
          return "";
        }
      },
    })
    .withAutomaticReconnect()
    .build();
};
